<template>
	<div class="ccls-details-modal-list">
		<div class="ccls-details-modal-list__title">Companies</div>
		<div class="ccls-details-modal-list__list" v-if="companiesCount != 0">
			<div
				class="ccls-details-modal-list__list-item"
				v-for="(item, key) in cclsData.companies"
				:key="`company_${key}`"
			>
				{{ item.text }}
			</div>
			<div
				class="ccls-details-modal-list__no-result"
				v-if="companiesCount == 0"
			>
				No results
			</div>
		</div>
		<div class="ccls-details-modal-list__title">Sub Locations</div>
		<div class="ccls-details-modal-list__list" v-if="locationsCount != 0">
			<div
				class="ccls-details-modal-list__list-item"
				v-for="(item, key) in cclsData.locations"
				:key="`location_${key}`"
			>
				{{ item.text }}
			</div>
			<div
				class="ccls-details-modal-list__no-result"
				v-if="locationsCount == 0"
			>
				No results
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CCLsDetailsModalList',
	props: {
		cclsData: {
			type: Object,
			default: () => {}
		}
	},
	computed: {
		companiesCount() {
			return this.cclsData.companies.length;
		},
		locationsCount() {
			return this.cclsData.locations.length;
		}
	}
};
</script>

<style lang="scss" scoped>
.ccls-details-modal-list {
	max-height: 250px;
	@include scrollbar;
	overflow-y: auto;

	&__title {
		@include heading('md');
		margin-bottom: $gutter-lg;
	}

	&__list {
		@include body-text('regular');

		&:not(:last-child) {
			margin-bottom: $gutter-xl;
		}
	}

	&__list-item {
		@include body-text('regular');

		&:not(:last-child) {
			margin-bottom: $gutter-md;
		}
	}

	&__no-result {
		&:not(:last-child) {
			margin-bottom: $gutter-xl;
		}
	}
}
</style>
